(function($) {

// equal heights
function equalHeight(group) {
  var tallest = 0;
  group.css('height','auto'); //otherwise only works once!
  group.each(function() {
    var thisHeight = $(this).height();
    if(thisHeight > tallest) {
      tallest = thisHeight;
    }
  });
  group.height(tallest);      
}

function align(){
  
    var minHeight = 0;

    if(($(window).width() > 740) || ($(window).width() > 740 && $(window).height() < 700) ){
      minHeight = $('.kopf-content').height() + $('.ScrollDown').height() + 20;
    } else {
      minHeight = 'auto';
    }

    if($(window).width() > 740){
      $('.fullheight').css({height:$(window).height()-$('#header').height()-150,minHeight: minHeight});
      $('.home .fullheight').css({height:$(window).height()-$('#header').height()-100,minHeight: minHeight}); // Startseite
      $('.page-template-page-home-php .fullheight').css({height:$(window).height()-$('#header').height()-100,minHeight: minHeight}); // Startseite Template
      $('.page-template-page-home-test-php .fullheight').css({height:$(window).height()-$('#header').height()-100,minHeight: minHeight}); // Test-Startseite
      $('.page-template-page-home-video-php .fullheight').css({height:$(window).height()-$('#header').height()-100,minHeight: minHeight}); // Video-Startseite
    }
    if($(window).width() > 900){
      $('.fullheight').css({height:$(window).height()-$('#header').height(),minHeight: minHeight});
      if($('body').hasClass('cookie-notice-visible')){
        $('.fullheight').css({height:$(window).height()-$('#header').height()-$('.new-cookie-notice').height(),minHeight: minHeight});
        //console.log("cookie-notice: " + $('.new-cookie-notice').height());
      }
      $('.home .fullheight').css({height:$(window).height()-$('#header').height()-100}); // Startseite
      $('.page-template-page-home-php .fullheight').css({height:$(window).height()-$('#header').height()-100}); // Startseite Template
      $('.page-template-page-home-test-php .fullheight').css({height:$(window).height()-$('#header').height()-100}); // Test-Startseite
      $('.page-template-page-home-video-php .fullheight').css({height:$(window).height()-$('#header').height()-100}); // Video-Startseite
    }
    if($(window).width() > 740 && $(window).height() < 700){
      $('.fullheight').css({height:$(window).height()-$('#header').height(),minHeight: minHeight});
      $('.home .fullheight').css({height:$(window).height()-$('#header').height(),minHeight: minHeight}); // Startseite
      $('.page-template-page-home-php .fullheight').css({height:$(window).height()-$('#header').height(),minHeight: minHeight}); // Startseite Template
      $('.page-template-page-home-test-php .fullheight').css({height:$(window).height()-$('#header').height(),minHeight: minHeight}); // Test-Startseite
      $('.page-template-page-home-video-php .fullheight').css({height:$(window).height()-$('#header').height(),minHeight: minHeight}); // Video-Startseite
      $('.fullheight.mitlogo').css({height:$(window).height()-$('#header').height(),minHeight: minHeight}); // Fullheight mit logo
    }

    if($(window).width() > 740 && $(window).height() > 600){
      $('#map-wrapper').css({height:$(window).height()-$('#header').height()-$('.kopfbereich.with-map').height()+1, minHeight:'480px'});
    }
    if($(window).width() > 740 && $(window).height() < 600){
      $('#map-wrapper').css({height:450, minHeight:'450px'});
    }
    if($(window).width() < 725){
      $('#map-wrapper').css({height:340, minHeight:'340px'});
    }
    else {
      
    }


    var cookieNoticeHeight = $( '.new-cookie-notice' ).outerHeight();
    var stickyHeaderHeight = $( '.stickyNavigation' ).outerHeight();
    var bodyPadding = stickyHeaderHeight + cookieNoticeHeight;    

    if ($('body').hasClass('cookie-notice-visible')) {
      $('.cookie-notice-visible #page').css({'padding-top': bodyPadding + 'px'});
      $('.stickyNavigation').css({'top': cookieNoticeHeight + 'px'});
    }


    var videoWidth = $('.video-js').width();
        
    var parentHeight =  $('.video-js').parent().parent().height();
    
    var parentWidth =  $('.video-js').parent().parent().width();


    if ($('#header').hasClass('tdvideo')) {
        var videoHeight = videoWidth/2.2222; // testdrive video
    } 
    if ($('.kopfbereich').hasClass('tourvideo')) {
        var videoHeight = videoWidth/2.4; // tour video
    } else {
        var videoHeight = videoWidth/1.7910; // all other videos
    }


    //if(parentHeight < videoHeight){

          //$('.video-js .vjs-tech').css({width:'100%',height:'auto'});  
          //
          //$('.video-js').css({width:'100%',height:'auto'});  
//
          //var offSetTop = -(videoHeight - parentHeight) / 2;
//
          //$('.video-js').css({height:videoHeight});
//
//
          //$('.video').css({height:videoHeight});
//
          //$('#video').css({marginTop:offSetTop,marginLeft:0});

     //}
     //else {
     //    
     //    $('.video-js .vjs-tech').css({width:'auto',height:'100%'});
     //    
     //    $('.video-js').css({width:'auto',height:'100%'});
     //    
     //    var videoWidth = $('.video-js .vjs-tech').width(); 
     //    
     //    var offSetLeft = -(videoWidth - parentWidth) / 2;
//
     //    $('#video').css({marginTop:0,marginLeft:offSetLeft});
//
     //    if ($('.kopfbereich').hasClass('tourvideo')) {
     //        $('#video').css({marginTop:0,marginLeft:0});
     //    }
     //}  
            
        
  // Hoehen syncen!!
  if($(window).width() > 725){
     /* events */  
     $('.sync .el').syncHeight();
     
     /* fahr-angebote */
     //$('.box ul.pros').syncHeight();
     //$('.box ul.facts').syncHeight();
     //$('.box .teaser ').syncHeight(); 

     equalHeight($('.box ul.pros'));
     equalHeight($('.box .legal-info'));
     equalHeight($('.box ul.facts'));
     equalHeight($('.box .teaser'));
     equalHeight($('.blog-items .j-text'));    
  }
  else {
    /* events */
     $('.sync .el').unSyncHeight();
  
     /* fahr-angebote */
     //$('.box ul.pros').unSyncHeight();
     //$('.box ul.facts').unSyncHeight();
     //$('.box .teaser ').unSyncHeight();

     $('.box .legal-info').css({'height': 'auto'});
     $('.box ul.pros').css({'height': 'auto'});
     $('.box ul.facts').css({'height': 'auto'});
     $('.box .teaser').css({'height': 'auto'});
     $('.blog-items .j-text').css({'height': 'auto'});
  }

  
  /* Timeline */
  //var position = $('.Timeline .Timestop:first').position();
  //var positionBottom = $('.Timeline .Timestop:last').position();
  //if(position){    
  //  $('.line').css({left:position.left - 12,top:position.top+10,height:positionBottom.top-position.top});
  //}    

  $('.Timeline').each(function () {
    var position = $(this).find('.Timestop:first').position();
    var positionBottom = $(this).find('.Timestop:last').position();
    if(position){    
      $(this).find('.line').css({left:position.left - 12,top:position.top+10,height:positionBottom.top-position.top});
    }   
  });  


} // align()

function lazyLoadImages(noWindowLoad) {

    $("div.lazy").lazyload({
        effect : "fadeIn",
        event : "sporty",
        load : function() {
            $(this).removeClass("loading");
            $(this).addClass("loaded");
        }
    });

    $("img.lazy").lazyload({
        effect : "fadeIn",
        event : "sporty",
        load : function() {
            $(this).siblings('.spinner').addClass("img-loaded");

        }
    });

    if (noWindowLoad) {
        var timeout = setTimeout(function() {

            $("div.lazy").trigger("sporty");
            $("img.lazy").trigger("sporty");

        }, 1);  
    } else {
      $(window).bind("load", function() {
          var timeout = setTimeout(function() {
  
              $("div.lazy").trigger("sporty");
              $("img.lazy").trigger("sporty");
  
          }, 1);
      });
    } 

    $("img.lazy").parent().append( "<div class='spinner'> <div class='double-bounce1'></div> <div class='double-bounce2'></div></div>" );

    // $( "img.lazy" ).parent().append( "<div class='spinner'> <div class='double-bounce1'></div> <div class='double-bounce2'></div></div>" );

    $(".fadein").each(function() {
        var src = $(this).data("src");
        var alt = $(this).data("alt");
        if (src) {
            var img = new Image();
            img.style.display = "none";
            img.onload = function() {
                $(this).siblings('.image-loader').detach();
                $(this).fadeIn(1000);
            };
            $(this).append(img);
            img.src = src;
            img.alt = alt;


        }
    });    

} // lazyLoadImages()

$(document).ready(function(){

  align();

  // change Menu class on scroll
  //$(window).scroll(function() {
  //  if ($(this).scrollTop() > 0) {
  //    $('#header.stickyNavigation').removeClass('notransition');
  //  } else {
  //    $('#header.stickyNavigation').addClass('notransition');
  //  }    
  //  if ($(this).scrollTop() > 100) {
  //    $('#header.stickyNavigation').addClass('reducedStickyNavigation');
  //  } else {
  //    $('#header.stickyNavigation').removeClass('reducedStickyNavigation');
  //  }
  //});
  
  $('.selectpicker').selectmenu();
  
  $('input[type="radio"]').ezMark();
  $('input[type="checkbox"]').ezMark();


  $('.accordion').find('h3').each(function () {
      $(this).prepend($('<span>').addClass('icon').addClass('icon-plus'));
      $(this).click(function (event) {
          event.preventDefault();
          var $h3 = $(event.target);
          var $div = $(event.target).next('div');

          $h3.find('.icon').toggleClass('icon-plus').toggleClass('icon-minus');

          if (!$div.is(':visible')) {
              $div.slideDown(250);
          } else {
              $div.slideUp(150);
          }
      });
  });

  $('.pseudo-accordion').find('.pseudo-accordion-trigger').each(function () {
      $(this).prepend($('<span>').addClass('icon').addClass('icon-arrow-right'));
      $(this).click(function (event) {
          event.preventDefault();
          var $pseudoAccordionTrigger = $(event.target);
          var $div = $(event.target).next('div');

          $pseudoAccordionTrigger.find('.icon').toggleClass('icon-arrow-right').toggleClass('icon-arrow-down');

          if (!$div.is(':visible')) {
              $div.slideDown(250);
          } else {
              $div.slideUp(150);
          }
      });
  }); 
  

  $('.ScrollDown').click(function(){
     var stickyHeaderHeight = $( '.stickyNavigation' ).outerHeight();
    
     $('html, body').animate({
      scrollTop: $(this).parent().parent().next().offset().top - stickyHeaderHeight
     }, 500);
    
     return false; 
  });

  $('#ScrollDownTour').click(function(){
    
     $('html, body').animate({
      scrollTop: $(this).parent().parent().next().next().offset().top
     }, 500);
    
     return false; 
  });

  $('.ScrollDownSpecial').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        $('html,body').animate({
          scrollTop: target.offset().top
        }, 500);
        return false;
      }
    }
  });
        
        function renderCounter(slick,carouselId) {
          var slidesToShow;
          if(slick.activeBreakpoint!==null){
            slidesToShow = slick.breakpointSettings[slick.activeBreakpoint].slidesToShow;
          } else {
            slidesToShow = slick.options.slidesToShow;
          }
    
          if($('#'+carouselId).next('.pager').find('.slick-next').length>0){
            $('#'+carouselId).next('.pager').find('.counter').html( (slick.currentSlide+slidesToShow)/slidesToShow +' / ' + Math.ceil((slick.slideCount)/slidesToShow));
            $('#'+carouselId).next('.pager').show();
          } else {
            $('#'+carouselId).next('.pager').find('.counter').html('');
            $('#'+carouselId).next('.pager').hide();
          }
        }         
        
        $('.Slider').each(function (idx, item) {
            var carouselId = "carousel" + idx;
            this.id = carouselId;
            $(this).attr('data-counter','carousel_slick-control_' + idx);
            $(this).next('.pager').attr('id','carousel_slick-control_' + idx);

            $(this).on('setPosition', function(event, slick) {
              //console.log('setPosition');
              renderCounter(slick,carouselId);
            });


            $(this).slick({
               
                dots: false,
                infinite: false,
                speed: 300,
                slidesToShow: 4,
                slidesToScroll: 4,
                appendArrows: $(this).next('.pager'),
                appendDots: $(this).next('.pager'),
                onAfterChange: function() {

                        var sln = $('#' + carouselId +' .slick-track .slick-active').size();
                        var cur =  $('#' + carouselId).slickCurrentSlide();
                        var curpage =  Math.ceil(cur / sln) +1;
                        $('#' + carouselId + '-currentSlide').next('.pager').find('.counter').html(curpage);

                },
                responsive: [
                  {
                        breakpoint: 1024,
                        settings: {
                          slidesToShow: 3,
                          slidesToScroll: 3,
                          dots: false
                        }
                  },
                  {
                        breakpoint: 600,
                        settings: {
                          slidesToShow: 2,
                          slidesToScroll: 2
                        }
                  },
                  {
                        breakpoint: 480,
                        settings: {
                          slidesToShow: 1,
                          slidesToScroll: 1
                        }
                  }
                ]
            });
         });

        $('.Slider-Team').each(function (idx, item) {
            var carouselId = "carousel" + idx;
            this.id = carouselId;
            $(this).attr('data-counter','carousel_slick-control_' + idx);
            $(this).next('.pager').attr('id','carousel_slick-control_' + idx);

            $(this).on('setPosition', function(event, slick) {
              //console.log('setPosition');
              renderCounter(slick,carouselId);
            });

            $(this).slick({
               
                dots: false,
                infinite: false,
                speed: 300,
                slidesToShow: 6,
                slidesToScroll: 6,
                rows: 0,
                appendArrows: $(this).next('.pager'),
                appendDots: $(this).next('.pager'),
                onAfterChange: function() {

                        var sln = $('#' + carouselId +' .slick-track .slick-active').size();
                        var cur =  $('#' + carouselId).slickCurrentSlide();
                        var curpage =  Math.ceil(cur / sln) +1;
                        $('#' + carouselId + '-currentSlide').next('.pager').find('.counter').html(curpage);


                },
                responsive: [
                  {
                        breakpoint: 1300,
                        settings: {
                          slidesToShow: 4,
                          slidesToScroll: 4,
                          dots: false
                        }
                  },
                  {
                        breakpoint: 1024,
                        settings: {
                          slidesToShow: 3,
                          slidesToScroll: 3,
                          dots: false
                        }
                  },
                  {
                        breakpoint: 600,
                        settings: {
                          slidesToShow: 2,
                          slidesToScroll: 2
                        }
                  },
                  {
                        breakpoint: 480,
                        settings: {
                          slidesToShow: 1,
                          slidesToScroll: 1
                        }
                  }
                ]
            });
         });

          $('.Single-Slider').each(function (idx, item) {
            var carouselId = "carousel-single-" + idx;
            this.id = carouselId;
            $(this).attr('data-counter','carousel_slick-control_' + idx);
            $(this).next('.pager').attr('id','carousel_slick-control_' + idx);

            $(this).on('setPosition', function(event, slick) {
              //console.log('setPosition');
              renderCounter(slick,carouselId);
            });

            $(this).slick({
               
                dots: false,
                infinite: true, 
                speed: 300,
                slidesToShow: 1,
                slidesToScroll: 1,
                rows: 0,
                appendArrows: $(this).next('.pager'),
                appendDots: $(this).next('.pager'),
                onAfterChange: function() {

                        var sln = $('#' + carouselId +' .slick-track .slick-active').size();

                        var cur =  $('#' + carouselId).slickCurrentSlide();
                        
                        var curpage =  Math.ceil(cur / sln) +1;  

                        $('#' + carouselId + '-currentSlide').next('.pager').find('.counter').html(curpage);



                }
            });
         });

          $('.Single-Slider-auto').each(function (idx, item) {
            var carouselId = "carousel-single-" + idx;
            this.id = carouselId;
            $(this).attr('data-counter','carousel_slick-control_' + idx);
            $(this).next('.pager').attr('id','carousel_slick-control_' + idx);

            $(this).on('setPosition', function(event, slick) {
              //console.log('setPosition');
              renderCounter(slick,carouselId);
            });

            $(this).slick({
                autoplay: true,
                autoplaySpeed: 4000,
                dots: false,
                infinite: true, 
                speed: 800,
                slidesToShow: 1,
                slidesToScroll: 1,
                rows: 0,
                appendArrows: $(this).next('.pager'),
                appendDots: $(this).next('.pager'),
                onAfterChange: function() {

                        var sln = $('#' + carouselId +' .slick-track .slick-active').size();

                        var cur =  $('#' + carouselId).slickCurrentSlide();
                        
                        var curpage =  Math.ceil(cur / sln) +1;  

                        $('#' + carouselId + '-currentSlide').next('.pager').find('.counter').html(curpage);



                }
            });
         });

        // ajax load more
        function getUrlParameter(name) {
          name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
          var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
          var results = regex.exec(location.search);
          return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
        }

        function setUrlParameter(key, value) {
            var baseUrl = [location.protocol, '//', location.host, location.pathname].join(''),
                urlQueryString = document.location.search,
                newParam = key + '=' + value,
                params = '?' + newParam;
            // If the "search" string exists, then build params from it
            if (urlQueryString) {
                var updateRegex = new RegExp('([\?&])' + key + '[^&]*');
                var removeRegex = new RegExp('([\?&])' + key + '=[^&;]+[&;]?');
        
                if( typeof value === 'undefined' || value === null || value === '' ) { // Remove param if value is empty
                    params = urlQueryString.replace(removeRegex, "$1");
                    params = params.replace( /[&;]$/, "" );
        
                } else if (urlQueryString.match(updateRegex) !== null) { // If param exists already, update it
                    params = urlQueryString.replace(updateRegex, "$1" + newParam);
        
                } else { // Otherwise, add it to end of query string
                    params = urlQueryString + '&' + newParam;
                }
            }
            // no parameter was set, remove the question mark
            params = params === '?' ? '' : params;
            window.history.replaceState({}, "", baseUrl + params);
        }

        function ajax_load_more (buttonWrap, postsWrap, restartPosts) {
          var $current_button_wrap = buttonWrap;
          var $current_posts_wrap = postsWrap;
          var current_restart_posts = restartPosts; 
          var currentPostsRelated = $current_posts_wrap.attr('data-posts-related');
          var currentPostsPerPage = $current_posts_wrap.attr('data-posts-per-page');                  
          var urlParamsMorePosts = getUrlParameter('moreposts');

          $.ajax({
            url : SiteParameters.ajax_url,
            type : 'GET',
            dataType: 'html',
            data: ({
              action: 'ajax_load_more',
              currentrestartposts: current_restart_posts,
              currentpostsrelated: currentPostsRelated,
              currentpostsperpage: currentPostsPerPage,
              currentmoreposts: urlParamsMorePosts,
              currentpostid: SiteParameters.post_id
            }),      
            beforeSend: function (xhr) {
              //$current_button_wrap.find('.button').text('Loading...');
            },
            success: function(data){
              if(data) { 
                var parsedData = jQuery.parseJSON(data);
                console.log("CurrentPostCount: " + parsedData.currentPostCount);
                console.log("CurrentFoundPosts: " + parsedData.currentFoundPosts);
                console.log("CurrentShownPosts: " + parsedData.currentShownPosts);
                console.log("CurrentPostsPerPage: " + parsedData.currentPostsPerPage);               

                if (current_restart_posts){
                  $current_posts_wrap.html(parsedData.output);
                } else {
                  $current_posts_wrap.append(parsedData.output);
                }              
      
                if ( parsedData.currentShownPosts >= parsedData.currentFoundPosts ){
                  $current_button_wrap.hide();
                } else {
                  $current_button_wrap.show();
                }

                lazyLoadImages(true);
                equalHeight($('.blog-items .j-text'));

              } else {
                $current_button_wrap.hide();
              }
            },
            error: function(data) {
              console.log("Error: " + data);
              return false;
            },
            complete: function() {    
              //console.log("Complete");                         
            }
          });
        }        


        // initial state
        if ($('#load-more-wrap').length) {
          if ( getUrlParameter('moreposts') === '' ) {
            $('#load-more-posts-wrap').html('');
            ajax_load_more($('#load-more-button-wrap'), $('#load-more-posts-wrap'));
            console.log("no moreposts");
          } else {
            $('#load-more-posts-wrap').html('');
            ajax_load_more($('#load-more-button-wrap'), $('#load-more-posts-wrap'), true);
            console.log("moreposts set");
          }  
        }

        $('#load-more-wrap').on('click', '.load-more-button', function() {
          var currentPostsWrap = $(this).closest('#load-more-wrap').find('#load-more-posts-wrap');
          var currentButtonWrap = $(this).closest('#load-more-button-wrap');
          var urlParamsMorePosts = getUrlParameter('moreposts');
          var parsedUPMP = parseInt(urlParamsMorePosts);
          var morePostsNum = 1;
          if ( typeof urlParamsMorePosts !== 'undefined' && urlParamsMorePosts !== null && !isNaN(parsedUPMP)) {
            morePostsNum = parsedUPMP + 1;
          }
          setUrlParameter('moreposts', morePostsNum);
          ajax_load_more(currentButtonWrap, currentPostsWrap);
        });  


        lazyLoadImages();

 });


$(window).on("load",function() {
    $(".fallingSnow").css('opacity',1);

     align();

});

$(window).resize(function() {

     align();

});

$(document).ready(function() {

    $(".fallingSnow").snowfall({deviceorientation : true, round : true, minSize: 1, maxSize:4,  flakeCount : 150});

});

})(jQuery);




/*  Snowfall jquery plugin

 ====================================================================
 LICENSE
 ====================================================================
 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
 ====================================================================

 Version 1.51 Dec 2nd 2012
 // fixed bug where snow collection didn't happen if a valid doctype was declared.

 Version 1.5 Oct 5th 2011
 Added collecting snow! Uses the canvas element to collect snow. In order to initialize snow collection use the following

 $(document).snowfall({collection : 'element'});

 element = any valid jquery selector.

 The plugin then creates a canvas above every element that matches the selector, and collects the snow. If there are a varrying amount of elements the
 flakes get assigned a random one on start they will collide.

 Version 1.4 Dec 8th 2010
 Fixed issues (I hope) with scroll bars flickering due to snow going over the edge of the screen.
 Added round snowflakes via css, will not work for any version of IE. - Thanks to Luke Barker of http://www.infinite-eye.com/
 Added shadows as an option via css again will not work with IE. The idea behind shadows, is to show flakes on lighter colored web sites - Thanks Yutt

 Version 1.3.1 Nov 25th 2010
 Updated script that caused flakes not to show at all if plugin was initialized with no options, also added the fixes that Han Bongers suggested

 Developed by Jason Brown for any bugs or questions email me at loktar69@hotmail
 info on the plugin is located on Somethinghitme.com

 values for snow options are

 flakeCount,
 flakeColor,
 flakeIndex,
 minSize,
 maxSize,
 minSpeed,
 maxSpeed,
 round, 		true or false, makes the snowflakes rounded if the browser supports it.
 shadow		true or false, gives the snowflakes a shadow if the browser supports it.

 Example Usage :
 $(document).snowfall({flakeCount : 100, maxSpeed : 10});

 -or-

 $('#element').snowfall({flakeCount : 800, maxSpeed : 5, maxSize : 5});

 -or with defaults-

 $(document).snowfall();

 - To clear -
 $('#element').snowfall('clear');
 */

(function($){
    $.snowfall = function(element, options){
        var	defaults = {
                flakeCount : 35,
                flakeColor : '#ffffff',
                flakeIndex: 999999,
                minSize : 1,
                maxSize : 2,
                minSpeed : 1,
                maxSpeed : 1,
                round : false,
                shadow : false,
                collection : false,
                collectionHeight : 40,
                deviceorientation : false
            },
            options = $.extend(defaults, options),
            random = function random(min, max){
                return Math.round(min + Math.random()*(max-min));
            };


        $(element).data("snowfall", this);

        // Snow flake object
        function Flake(_x, _y, _size, _speed, _id)
        {
            // Flake properties
            this.id = _id;
            this.x  = _x;
            this.y  = _y;
            this.size = _size;
            this.speed = _speed;
            this.step = 0;
            this.stepSize = random(1,10) / 100;

            if(options.collection){
                this.target = canvasCollection[random(0,canvasCollection.length-1)];
            }

            var flakeMarkup = $(document.createElement("div")).attr({'class': 'snowfall-flakes', 'id' : 'flake-' + this.id}).css({'width' : this.size, 'height' : this.size, 'background' : options.flakeColor, 'position' : 'absolute', 'top' : this.y, 'left' : this.x, 'fontSize' : 0, 'zIndex' : options.flakeIndex});

            if($(element).get(0).tagName === $(document).get(0).tagName){
                $('body').append(flakeMarkup);
                element = $('body');
            }else{
                $(element).append(flakeMarkup);
            }

            this.element = document.getElementById('flake-' + this.id);

            // Update function, used to update the snow flakes, and checks current snowflake against bounds
            this.update = function(){
                this.y += this.speed;

                if(this.y > (elHeight) - (this.size  + 6)){
                    this.reset();
                }

                this.element.style.top = this.y + 'px';
                this.element.style.left = this.x + 'px';

                this.step += this.stepSize;

                if (doRatio === false) {
                    this.x += Math.cos(this.step);
                } else {
                    this.x += (doRatio + Math.cos(this.step));
                }

                // Pileup check
                if(options.collection){
                    if(this.x > this.target.x && this.x < this.target.width + this.target.x && this.y > this.target.y && this.y < this.target.height + this.target.y){
                        var ctx = this.target.element.getContext("2d"),
                            curX = this.x - this.target.x,
                            curY = this.y - this.target.y,
                            colData = this.target.colData;

                        if(colData[parseInt(curX)][parseInt(curY+this.speed+this.size)] !== undefined || curY+this.speed+this.size > this.target.height){
                            if(curY+this.speed+this.size > this.target.height){
                                while(curY+this.speed+this.size > this.target.height && this.speed > 0){
                                    this.speed *= .5;
                                }

                                ctx.fillStyle = "#fff";

                                if(colData[parseInt(curX)][parseInt(curY+this.speed+this.size)] == undefined){
                                    colData[parseInt(curX)][parseInt(curY+this.speed+this.size)] = 1;
                                    ctx.fillRect(curX, (curY)+this.speed+this.size, this.size, this.size);
                                }else{
                                    colData[parseInt(curX)][parseInt(curY+this.speed)] = 1;
                                    ctx.fillRect(curX, curY+this.speed, this.size, this.size);
                                }
                                this.reset();
                            }else{
                                // flow to the sides
                                this.speed = 1;
                                this.stepSize = 0;

                                if(parseInt(curX)+1 < this.target.width && colData[parseInt(curX)+1][parseInt(curY)+1] == undefined ){
                                    // go left
                                    this.x++;
                                }else if(parseInt(curX)-1 > 0 && colData[parseInt(curX)-1][parseInt(curY)+1] == undefined ){
                                    // go right
                                    this.x--;
                                }else{
                                    //stop
                                    ctx.fillStyle = "#fff";
                                    ctx.fillRect(curX, curY, this.size, this.size);
                                    colData[parseInt(curX)][parseInt(curY)] = 1;
                                    this.reset();
                                }
                            }
                        }
                    }
                }

                if(this.x > (elWidth) - widthOffset || this.x < widthOffset){
                    this.reset();
                }
            }

            // Resets the snowflake once it reaches one of the bounds set
            this.reset = function(){
                this.y = 0;
                this.x = random(widthOffset, elWidth - widthOffset);
                this.stepSize = random(1,10) / 100;
                this.size = random((options.minSize * 100), (options.maxSize * 100)) / 100;
                this.speed = random(options.minSpeed, options.maxSpeed);
            }
        }

        // Private vars
        var flakes = [],
            flakeId = 0,
            i = 0,
            elHeight = $(element).height(),
            elWidth = $(element).width(),
            widthOffset = 0,
            snowTimeout = 0;

        // Collection Piece ******************************
        if(options.collection !== false){
            var testElem = document.createElement('canvas');
            if(!!(testElem.getContext && testElem.getContext('2d'))){
                var canvasCollection = [],
                    elements = $(options.collection),
                    collectionHeight = options.collectionHeight;

                for(var i =0; i < elements.length; i++){
                    var bounds = elements[i].getBoundingClientRect(),
                        canvas = document.createElement('canvas'),
                        collisionData = [];

                    if(bounds.top-collectionHeight > 0){
                        document.body.appendChild(canvas);
                        canvas.style.position = 'absolute';
                        canvas.height = collectionHeight;
                        canvas.width = bounds.width;
                        canvas.style.left = bounds.left + 'px';
                        canvas.style.top = bounds.top-collectionHeight + 'px';

                        for(var w = 0; w < bounds.width; w++){
                            collisionData[w] = [];
                        }

                        canvasCollection.push({element :canvas, x : bounds.left, y : bounds.top-collectionHeight, width : bounds.width, height: collectionHeight, colData : collisionData});
                    }
                }
            }else{
                // Canvas element isnt supported
                options.collection = false;
            }
        }
        // ************************************************

        // This will reduce the horizontal scroll bar from displaying, when the effect is applied to the whole page
        if($(element).get(0).tagName === $(document).get(0).tagName){
            widthOffset = 25;
        }

        // Bind the window resize event so we can get the innerHeight again
        $(window).bind("resize", function(){
            elHeight = $(element).height();
            elWidth = $(element).width();
        });


        // initialize the flakes
        for(i = 0; i < options.flakeCount; i+=1){
            flakeId = flakes.length;
            flakes.push(new Flake(random(widthOffset,elWidth - widthOffset), random(0, elHeight), random((options.minSize * 100), (options.maxSize * 100)) / 100, random(options.minSpeed, options.maxSpeed), flakeId));
        }

        // This adds the style to make the snowflakes round via border radius property
        if(options.round){
            $('.snowfall-flakes').css({'-moz-border-radius' : options.maxSize, '-webkit-border-radius' : options.maxSize, 'border-radius' : options.maxSize});
        }

        // This adds shadows just below the snowflake so they pop a bit on lighter colored web pages
        if(options.shadow){
            $('.snowfall-flakes').css({'-moz-box-shadow' : '1px 1px 1px #555', '-webkit-box-shadow' : '1px 1px 1px #555', 'box-shadow' : '1px 1px 1px #555'});
        }

        // On newer Macbooks Snowflakes will fall based on deviceorientation
        var doRatio = false;
        if (options.deviceorientation) {
            $(window).bind('deviceorientation', function(event) {
                doRatio = event.originalEvent.gamma * 0.1;
            });
        }

        // this controls flow of the updating snow
        function snow(){
            for( i = 0; i < flakes.length; i += 1){
                flakes[i].update();
            }

            snowTimeout = setTimeout(function(){snow()}, 30);
        }

        snow();

        // Public Methods

        // clears the snowflakes
        this.clear = function(){
            $(element).children('.snowfall-flakes').remove();
            flakes = [];
            clearTimeout(snowTimeout);
        };
    };

    // Initialize the options and the plugin
    $.fn.snowfall = function(options){
        if(typeof(options) == "object" || options == undefined){
            return this.each(function(i){
                (new $.snowfall(this, options));
            });
        }else if (typeof(options) == "string") {
            return this.each(function(i){
                var snow = $(this).data('snowfall');
                if(snow){
                    snow.clear();
                }
            });
        }
    };
})(jQuery);



















